import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=7024eb90&scoped=true"
import script from "./RequestList.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RequestList.vue?vue&type=style&index=0&id=7024eb90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7024eb90",
  null
  
)

export default component.exports